export const povType = [
  { value: '1', label: '产科门诊' },
  { value: '2', label: '儿童门诊' },
  { value: '3', label: '成人门诊' },
  { value: '4', label: '狂犬病暴露处置门诊' },
  { value: '5', label: '新冠门诊' },
  { value: '6', label: '成人流感门诊' }
]

export function convertToArrTxt(value) {
  let arr = []
  const data = value.split(',')
  data.forEach(v => {
    povType.forEach(item => {
      if (v == item.value) {
        arr.push(item.label)
      }
    })
  })
  return arr
}
